<template>
	<div class="page container page--auth">
		<div class="page__info">
			<div class="page__info--title">
				Create an account
			</div>
		</div>
		<div class="google-auth-wrapper">
			<SignInWithGoogleButton @onSuccess="handleOnSuccessGoogleAuth">
				Sign up with Google
			</SignInWithGoogleButton>
			<p>OR</p>
		</div>
		<div>
			<validation-observer
				data-element="form"
				tag="form"
				ref="form"
				@submit.prevent="submit"
			>
				<input-field
					name="First name"
					type="text"
					rules="required|max:32"
					v-model="profile.firstName"
				/>
				<input-field
					name="Last name"
					type="text"
					rules="required|max:32"
					v-model="profile.lastName"
				/>
				<input-field
					name="Email address"
					type="email"
					autocomplete="username"
					rules="required|max:50"
					v-model="profile.email"
				/>
				<select-field
					name="Your experience level"
					rules="required"
					:options="experienceLevelOptions.slice(0,8)"
					v-model="profile.experienceLevel"
				/>
				<select-field
					name="Your preferred bidding system"
					rules="required"
					:options="biddingSystemOptions"
					v-model="profile.biddingSystem"
				/>
				<input-field
					name="Password"
					type="password"
					autocomplete="new-password"
					rules="required|min:8|max:32"
					v-model="profile.password"
				/>
				<input-field
					name="Confirm password"
					type="password"
					autocomplete="new-password"
					rules="required|confirmed:password|max:32"
					v-model="profile.passwordConfirm"
				/>
				<checkbox-field
					name="I would like to be contacted by Bridge128 to hear about updates and news"
					v-model="profile.gdprConsent"
				/>
				<actions
					:actions="actions"
					:isWaiting="isWaiting"
				/>
			</validation-observer>
		</div>
	</div>
</template>

<route>
	{
		"meta": {
			"isPublicOnly": true
		}
	}
</route>

<script>
	import InputField            from '@/components/forms/InputField';
	import SelectField           from '@/components/forms/SelectField';
	import CheckboxField         from '@/components/forms/CheckboxField';
	import Actions               from '@/components/ui/Actions';
	import actionClick           from '@/mixins/actionClick';
	import invalidFormMessage    from '@/mixins/invalidFormMessage';
	import { experienceLevels }  from '@/consts';
	import { biddingSystems }    from '@/consts';
	import SignInWithGoogleButton from '../components/auth/SignInWithGoogleButton.vue';

	export default {
		layout: 'v2default',
		metaInfo: {
			title: 'Create new account'
		},
		components: {
			SignInWithGoogleButton,
			InputField,
			SelectField,
			CheckboxField,
			Actions
		},
		mixins: [actionClick, invalidFormMessage],
		data: () => ({
			isWaiting: undefined,
			experienceLevelOptions: experienceLevels,
			biddingSystemOptions: biddingSystems,
			profile: {
				email:            '',
				firstName:        '',
				lastName:         '',
				experienceLevel:  '',
				biddingSystem:    '',
				password:         '',
				passwordConfirm:  '',
				timezone:         undefined,
				gdprConsent:      false
			},
			actions: {
				primary: [
					{
						text: 'Create',
						type: 'submit',
						btnId: 'submit'
					}
				],
				secondary: [
					{
						text: 'Cancel',
						route: '/login'
					}
				]
			}
		}),
		computed: {
			getBreadcrumbs () {
				return [
					{
						path: '/create-account',
						text: 'Create an account'
					}
				];
			}
		},
		created () {
			this.$store.commit('ui/setBreadcrumbs', {
				breadcrumbs: this.getBreadcrumbs
			});
			this.$store.commit('ui/setLoadingIsHidden');
		},
		methods: {
			async submit () {
				const valid = await this.$refs.form.validate();
				if (!valid) {
					this.showInvalidFormMessage();
					return;
				}
				this.isWaiting = 'submit';
				await this.$store.dispatch('auth/createAccount', {
					profile: {
						...this.profile,
						timezone: Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || 'Europe/London'
					}
				});
				this.isWaiting = undefined;
			},
			async handleOnSuccessGoogleAuth (response) {
				if (response.code) {
					await this.$store.dispatch('auth/signInWithGoogle', {
						code: response.code,
						gdprConsent: !!this.profile?.gdprConsent
					});
				}
			}
		}
	};

</script>

<style lang="scss" scoped>

.page {
	&--auth {
		max-width: 640px;

		.google-auth-wrapper {
			margin-top: rem(20);
			p {
				text-align: center;
				font-size: 18px;
				line-height: 22px;
				color: $c-brand-grey-lighter-1;
				margin-top: rem(20);
			}
		}
	}

  &__info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;

    &--title {
      font-size: 46px;
      margin-bottom: 24px;
    }
  }
}

</style>
